<template>
  <div class="courseInfo flex">
    <div  class="courseInfoL pointer" @click="$emit('routerLinkHome')">
      <img src="../../../static/zhishimaoL.png" alt="知视猫">
<!--      <img src="https://lf3-cdn-tos.bytegoofy.com/goofy/academy/web/img/logo.de99765a.svg" alt="巨量学">-->
    </div>

    <div class="courseInfoR flex" v-if="userInfo!==''">
      <router-link to="/user"> 个人中心 </router-link>
      <div class="delimiter"></div>
      <div class="userInfo pointer">
        <el-dropdown @visible-change="changeVisible" icon="el-icon--right">
          <span class="el-dropdown-link flex">
           <img v-if="userInfo.avatar" :src="userInfo.avatar" alt="头像" class="avatar">
            <img v-else src="https://file.jinglinshe.com/zsm-h5-user-info2.png" alt="头像" class="avatar">
            <i v-if="dropdownShow==false" class="el-icon-caret-bottom caret-bottom el-icon--right"></i>
            <i v-else class=" el-icon-caret-top el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item> <div @click.stop="goAvatarHome(1)">返回用户中心</div> </el-dropdown-item>
            <el-dropdown-item> <div @click.stop="goAvatarHome(2)">我的订单</div> </el-dropdown-item>
            <el-dropdown-item> <div @click.stop="loginOut">退出</div> </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>


    <div class="courseInfoR flex" v-else>
      <div class="delimiter"></div>
      <router-link to="/login" style="padding-left: 12px;"> 登录 </router-link>
    </div>
  </div>
</template>

<script>
  import {
    clearLocalStorage,
    removeToken,
    getLocalStorage
  } from '@/utils/auth.js'
  export default {
    data() {
      return {
        dropdownShow:false//展示隐藏
      }
    },
    mounted() {
    },
    computed:{
      userInfo(){
        return JSON.parse(getLocalStorage('buyerInfo'))
      }
    },
    methods: {
      // 退出
      loginOut(){
        clearLocalStorage()
        removeToken('mobile')
        removeToken('password')
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      },
      goAvatarHome(type){
        if(type==1){
          this.$router.push('/user')
        }else{
          this.$router.push('/user/order')
        }
      },
      changeVisible(e){
        this.dropdownShow=e
      }
    }
  }
</script>
<style lang="scss">
  .el-dropdown-menu {
    border: none;
    border-radius: 4px;
    padding: 0;
    margin: 0;
    .popper__arrow{
      display: none;
    }
   li {
      display: block;
      padding: 0 24px;
      height: 54px;
      font-size: 14px;
      line-height: 54px!important;
      &:hover {
        background-color: #f0f0f0!important;
      }
      // .el-icon-caret-top{
      //   -webkit-transition: -webkit-transform 0.5s ease;
      //    transform:rotate(180deg) ;
      // }
    }
  }
</style>
<style lang="scss" scoped="scoped">
  .courseInfo::v-deep {
    width: 100%;
    height: 64px;
    padding: 0 18px 0 40px;
    justify-content: space-between;
    align-items: center;




    .userInfo {
      align-items: center;
      padding-top: 5px;
      .el-dropdown-link{
        align-items: center;
      }
      .avatar {
        border-radius: 50%;
        width: 30px;
        height: 30px;
      }

      .caret-bottom,.el-icon-caret-top {
        font-size: 20px;
        line-height: 25px;
      }
    }

    .courseInfoL {
      width: 168px;
      /*height: 24px;*/
      height: 82px;
      img {
        width: 100%;
        height: 100%
      }
    }

    .courseInfoR {
      align-items: center;
      width: 260px;
      justify-content: flex-end;

      a {
        color: #333;
        font-size: 14px;
      }


      .delimiter {
        width: 1px;
        height: 25px;
        margin: 0 12px;
        background-color: #ebebeb;
      }
    }
  }
</style>
